import { extendTheme } from '@chakra-ui/react'
import { components } from 'react-select'
export const ExtendedTheme = extendTheme({
  colors: {
    primary: 'rgb(163, 0, 70)',
    brand: {
      100: '#f7fafc',
      // ...Snap-Fire-Collars-Logo
      900: '#1a202c'
    }
  }
})
